/*
  Melanin Poise Theme JavaScript
  Interactive functionality and cart management
*/

(function() {
  'use strict';

  // ========================================
  // HEADER FUNCTIONALITY
  // ========================================

  // Mobile menu toggle
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const mobileMenuClose = document.getElementById('mobile-menu-close');

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function() {
      mobileMenuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Close mobile menu when clicking overlay
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function(e) {
      if (e.target === mobileMenuOverlay) {
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // Mobile submenu toggles
  const submenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const navItem = this.closest('.mobile-nav-item');
      navItem.classList.toggle('open');
    });
  });

  // ========================================
  // SEARCH FUNCTIONALITY
  // ========================================

  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.querySelector('.search-input');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      searchBar.classList.add('active');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 300);
      }
    });
  }

  if (searchClose && searchBar) {
    searchClose.addEventListener('click', function() {
      searchBar.classList.remove('active');
    });
  }

  // Close search on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchBar) {
      searchBar.classList.remove('active');
    }
  });

  // ========================================
  // HEADER SCROLL BEHAVIOR
  // ========================================

  let lastScroll = 0;
  const header = document.getElementById('site-header');

  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;

    if (header) {
      if (currentScroll > 100) {
        header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
      } else {
        header.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.05)';
      }
    }

    lastScroll = currentScroll;
  });

  // ========================================
  // CART FUNCTIONALITY
  // ========================================

  // Update cart count in header
  function updateCartCount(count) {
    const cartCount = document.getElementById('cart-count');
    if (cartCount) {
      cartCount.textContent = count;
      if (count > 0) {
        cartCount.style.display = 'flex';
      } else {
        cartCount.style.display = 'none';
      }
    }
  }

  // Add to cart functionality
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const addToCartBtn = document.getElementById('add-to-cart-btn');
      const originalText = addToCartBtn.innerHTML;
      
      // Show loading state
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
      
      fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            updateCartCount(cart.item_count);
          });
        
        // Show success message
        addToCartBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
        addToCartBtn.style.background = '#10B981';
        
        // Reset button after 2 seconds
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = originalText;
          addToCartBtn.style.background = '';
        }, 2000);
        
        // Optional: Show mini cart or notification
        showCartNotification(data);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = originalText;
        alert('Error adding item to cart. Please try again.');
      });
    });
  }

  // Show cart notification (simple version)
  function showCartNotification(item) {
    // Create notification element
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: white;
      padding: 20px;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      z-index: 10000;
      max-width: 350px;
      animation: slideInRight 0.3s ease;
    `;
    
    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 15px;">
        <i class="fas fa-check-circle" style="color: #10B981; font-size: 24px;"></i>
        <div>
          <p style="font-weight: 700; margin-bottom: 5px;">Added to cart!</p>
          <p style="font-size: 14px; color: #718096;">${item.product_title}</p>
        </div>
      </div>
      <div style="display: flex; gap: 10px; margin-top: 15px;">
        <a href="/cart" style="flex: 1; padding: 10px; background: #8B5CF6; color: white; text-align: center; border-radius: 6px; text-decoration: none; font-weight: 700; font-size: 14px;">View Cart</a>
        <button onclick="this.parentElement.parentElement.remove()" style="flex: 1; padding: 10px; background: #f7fafc; color: #1a1a1a; border: none; border-radius: 6px; cursor: pointer; font-weight: 700; font-size: 14px;">Continue Shopping</button>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 5000);
  }

  // Add animation styles
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(400px);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // ========================================
  // CART PAGE FUNCTIONALITY
  // ========================================

  // Update cart item quantity
  window.updateCartQuantity = function(lineKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Reload page to update cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      alert('Error updating cart. Please try again.');
    });
  };

  // Remove cart item
  window.removeCartItem = function(lineKey) {
    if (confirm('Remove this item from cart?')) {
      updateCartQuantity(lineKey, 0);
    }
  };

  // ========================================
  // PRODUCT PAGE VARIANT SELECTION
  // ========================================

  // This is a simplified version - for production, use Shopify's option selection script
  const variantSelectors = document.querySelectorAll('.variant-option input');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      const optionName = this.name;
      const selectedValue = this.value;
      
      // Update displayed selected value
      const selectedValueDisplay = document.getElementById('selected-' + optionName);
      if (selectedValueDisplay) {
        selectedValueDisplay.textContent = selectedValue;
      }
      
      // In production, this would need to find the matching variant
      // and update price, availability, etc.
    });
  });

  // ========================================
  // LAZY LOADING IMAGES
  // ========================================

  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });

    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // ========================================
  // SMOOTH SCROLL TO ANCHORS
  // ========================================

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#!') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // ========================================
  // COLLECTION FILTERS (CLIENT-SIDE)
  // ========================================

  window.filterProducts = function() {
    const productCards = document.querySelectorAll('.product-card');
    const checkedFilters = Array.from(document.querySelectorAll('.filter-option input:checked'))
      .map(input => input.value);
    
    productCards.forEach(card => {
      // Simple show/hide based on filters
      // In production, this would be more sophisticated
      card.style.display = 'block';
    });
  };

  // ========================================
  // NEWSLETTER FORM
  // ========================================

  const newsletterForms = document.querySelectorAll('.newsletter-form, #newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      // Default Shopify form submission will handle this
      // But you can add custom success messages here
      const submitBtn = this.querySelector('button[type="submit"]');
      if (submitBtn) {
        const originalText = submitBtn.innerHTML;
        submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
        submitBtn.disabled = true;
        
        // Re-enable after form submission
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });

  // ========================================
  // INITIALIZE AOS (Animate On Scroll)
  // ========================================

  // Simple fade-in on scroll effect
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Apply fade-in effect to elements with data-aos attribute
  document.querySelectorAll('[data-aos]').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    fadeInObserver.observe(el);
  });

  // ========================================
  // INITIALIZE ON PAGE LOAD
  // ========================================

  // Update cart count on page load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartCount(cart.item_count);
    })
    .catch(error => console.error('Error fetching cart:', error));

  // Log theme loaded
  console.log('Melanin Poise theme loaded successfully! ✨');

})();
